
interface SpinnerProps {
  size?: number;
  label?: string;
}

export function Spinner({ size = 32, label }: SpinnerProps) {
  return (
    <div className="spinner-wrap" role="status" aria-label={label ?? 'Loading'}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 50 50"
        fill="none"
        aria-hidden="true"
        className="spinner-svg"
      >
        <circle
          cx="25"
          cy="25"
          r="20"
          stroke="currentColor"
          strokeWidth="4"
          strokeDasharray="94 31"
          strokeLinecap="round"
        />
      </svg>
      {label && <span className="spinner-label">{label}</span>}
    </div>
  );
}
